<script>
import Base from '@/plans/ZOOM_SCHEDULER/config/base';
import store from '@/store/index';

export default {
  extends: Base,
  computed: {
    alertMsg() {
      const { boughtBizBundle } = store.getters.plansofBizBundle;
      return boughtBizBundle?.length > 0 ? this.$t('billing.scheduler.biz_include_tip') : '';
    },
  },
};
</script>
